import { Reducer } from "../../lib/redux";
import { IHosProcessResult } from "../../services/hosProcess";
import { extend } from "../../utils/vanilla";
import { HosRuleResultsActions } from "./actions";
import { HosRuleResultsActionTypes } from "./types";

export interface IHosRuleResult {
    ruleResult: IHosProcessResult;
    afterSync: boolean;
}

export let defaultHosRuleResults: IIdDictionary<IHosRuleResult> = {};

export let hosRuleResults: Reducer<IIdDictionary<IHosRuleResult>, HosRuleResultsActions> = (state = defaultHosRuleResults, action) => {
    switch (action.type) {
        case HosRuleResultsActionTypes.SET_HOS_RULE_RESULTS: {
            const userId = action.payload.userId;
            const ruleResult = action.payload.ruleResult ? extend(true, {}, action.payload.ruleResult) : null;
            const afterSync = action.payload.afterSync ?? false;
            if (userId && ruleResult) {
                return {
                    ...state,
                    [userId]: {
                        ruleResult: ruleResult,
                        afterSync
                    }
                };
            }
            return state;
        }
        case HosRuleResultsActionTypes.CLEAR_HOS_RULE_RESULTS: {
            const userId = action.payload.userId;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return defaultHosRuleResults;
        }
        default:
            return state;
    }
};
